import { render, staticRenderFns } from "./AssetLocationArea.vue?vue&type=template&id=971db0ba&scoped=true&"
import script from "./AssetLocationArea.vue?vue&type=script&lang=js&"
export * from "./AssetLocationArea.vue?vue&type=script&lang=js&"
import style0 from "./AssetLocationArea.vue?vue&type=style&index=0&id=971db0ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971db0ba",
  null
  
)

export default component.exports